import { Tabs } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { SectionLayout } from '../../../../types';
import { useSectionMutations } from '../../../../mutations/sections';
import { useActiveSection } from '../../../../queries/guides';
import {
  Icon1Col,
  Icon1ColLeft,
  Icon1ColRight,
  Icon2Col,
  Icon3Col,
} from '@bynder/icons';

export const SectionLayoutEditor = () => {
  const { translate } = useTranslate();
  const { activeSection } = useActiveSection();
  const { changeColumnLayout } = useSectionMutations();

  const activeLayout = activeSection?.sectionLayout;

  const handleChangeLayout = (newSectionLayout: SectionLayout) => {
    if (activeLayout !== newSectionLayout) {
      changeColumnLayout.mutate({
        sectionId: activeSection.id,
        sectionLayout: newSectionLayout,
      });
    }
  };

  const SectionLayoutMap = [
    {
      type: SectionLayout.SINGLE,
      label: translate('SECTION_MENU.COLUMN_TEXT', { count: 1 }),
      icon: <Icon1Col />,
    },
    {
      type: SectionLayout.DOUBLE_50_50,
      label: translate('SECTION_MENU.COLUMN_TEXT', { count: 2 }) + ' (50/50)',
      icon: <Icon2Col />,
    },
    {
      type: SectionLayout.DOUBLE_33_66,
      label: translate('SECTION_MENU.COLUMN_TEXT', { count: 2 }) + ' (30/70)',
      icon: <Icon1ColLeft />,
    },
    {
      type: SectionLayout.DOUBLE_66_33,
      label: translate('SECTION_MENU.COLUMN_TEXT', { count: 2 }) + ' (70/30)',
      icon: <Icon1ColRight />,
    },
    {
      type: SectionLayout.TRIPLE_33_33_33,
      label: translate('SECTION_MENU.COLUMN_TEXT', { count: 3 }),
      icon: <Icon3Col />,
    },
  ];

  return (
    <Tabs variant="clean">
      {SectionLayoutMap.map(layout => (
        <Tabs.Tab
          data-testid={`layout-option-${layout.type}`}
          label={layout.label}
          key={layout.type}
          isLabelHidden
          isActive={activeLayout === layout.type}
          onClick={() => handleChangeLayout(layout.type)}
          icon={layout.icon}
        />
      ))}
    </Tabs>
  );
};
